import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const StoreStatusCtx = createContext({ isOpen: true, refresh: () => {} });

export const useStoreStatus = () => useContext(StoreStatusCtx);

export function StoreStatusProvider({ children }) {
  const [isOpen, setIsOpen] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/store-status");
      setIsOpen(!!data.is_open);
    } catch {
      // On error, default to open (don't block customers from a transient API issue)
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    // Re-poll every 30s so customers see status changes without reloading
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  return <StoreStatusCtx.Provider value={{ isOpen, refresh }}>{children}</StoreStatusCtx.Provider>;
}
